var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBrush16 = function SvgBrush16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5 9.75 5.142-7.196a2.342 2.342 0 1 1 3.304 3.304L7.25 12m-5.5 2.25s.81-1.307 1-2.25c.038-.19.06-.405.07-.626.04-.863.693-1.624 1.558-1.624H5A2.25 2.25 0 0 1 7.25 12v0A2.25 2.25 0 0 1 5 14.25H1.75Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgBrush16;